<template>
  <ListLayout
    :context="context"
    :title="`${tripPlanningModule.planningTemplatePlural}`"
    :tableData="tripPlanTemplateList"
    :tableHeader="tableHeaders"
    :total="totalItems"
    :initial-call="true"
    @getList="getTripPlanningTemplateList"
    ref="listTable"
  >
    <template #listAction>
      <PrimaryButton
        id="planningTemplatesAdd"
        v-if="permissions && permissions.add"
        @click="
          $router.push({
            name: 'add-trip-planning-template',
          })
        "
        :name="`Add ${tripPlanningModule.planningTemplate}`"
        icon="mdi-plus"
        iconSize="x-large"
      >
      </PrimaryButton>
    </template>
    <template #rightFilterSlot>
      <div class="d-flex align-center justify-end w-100">
        <RefreshListButton
          id="planningTemplateRefreshList"
          :isIcon="false"
          @click="$refs.listTable.searchTriggered()"
        />
      </div>
    </template>
    <template #dialogs>
      <TripPlanningTemplateDetailsDialog
        v-model="showTemplateDetails"
        :templateId="selectedTemplateID"
      />
    </template>
  </ListLayout>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import { returnToday } from "@/utils/functions";
import { bus } from "@/main";
import TripPlanningTemplateButton from "@/components/Button/TripPlanningTemplateButton.vue";
import TripPlanningTemplateDetailsDialog from "@/components/ModuleBasedComponents/TripPlanningTemplate/TripPlanningTemplateDetailsDialog.vue";
import RefreshListButton from "@/components/BaseComponents/RefreshListButton.vue";
import { tripPlanningModule } from "@/utils/moduleMapping";

export default {
  components: {
    ListLayout,
    TripPlanningTemplateButton,
    TripPlanningTemplateDetailsDialog,
    RefreshListButton,
  },
  data() {
    return {
      tripPlanningModule,
      returnToday,
      permissions: null,
      tripPlanTemplateList: [],
      totalItems: 0,
      headerSelected: [
        {
          headerName: "Template Name",
          field: "name",
          sortable: true,
        },
        {
          headerName: "Configuration",
          field: "configuration",
          sortable: false,
        },
        {
          headerName: "Fill Ratio",
          field: "fill_ratio",
          sortable: true,
        },
      ],
      tripPlanningTemplateForm: {},
      formErrors: {},

      templateList: [],
      driverList: [],

      showTemplateDetails: false,
      selectedTemplateID: null,
    };
  },
  computed: {
    context() {
      return { parentComponent: this };
    },
    selectedBranch() {
      let obj = this.$helper.getUserDetailsLocalStorage();
      if (obj) {
        return obj.preferred_branch.id;
      } else {
        return null;
      }
    },
    tableHeaders() {
      return [
        ...this.headerSelected,
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          sortable: false,
          minWidth: "200",
          cellRenderer: "TripPlanningTemplateButton",
        },
      ];
    },
  },
  methods: {
    getTripPlanningTemplateList(params = {}) {
      params = {
        ...params,
        branch: this.selectedBranch,
      };
      bus.$emit("showLoader", true);
      this.$api.tripPlanningTemplate
        .getTripPlanningTemplateList(params)
        .then((res) => {
          this.tripPlanTemplateList = res.data;
          this.totalItems = res.count;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
  created() {
    this.permissions = this.$permissions.getPermission("trip_planning");
  },
};
</script>

<style></style>
